import React from "react";
import headerstyles from "./header.module.css";
import basestyles from "../../styles/basestyles.module.css";

export default function Header(props) {
  return (
    <div className={basestyles.headerWidth}>
      <h1 className={headerstyles.headName} style={props.style}>
        {props.name}
      </h1>
    </div>
  );
}
